// Mock data for DECAMONDO BOSPHOURUS ISTANBUL — demo only

export const brand = {
  name: 'DECAMONDO',
  location: 'BOSPHOURUS ISTANBUL',
  phone: '+90 212 000 00 00',
  email: 'reservations@decamondo.demo',
  address: 'Çırağan Cd. No: 1, Beşiktaş 34349, Istanbul, Türkiye',
};

export const heroVideo = {
  // Free stock cinematic Bosphorus / luxury b-roll (Coverr / Mixkit / CDN)
  src: 'https://videos.pexels.com/video-files/2169880/2169880-uhd_3840_2160_30fps.mp4',
  poster: 'https://images.unsplash.com/photo-1665512961534-7d42056eeedf?auto=format&fit=crop&w=2400&q=80',
};

export const experiences = [
  {
    id: 'e1',
    tag: 'Signature Offer',
    title: 'A Bosphorus Awakening',
    desc: 'Sunrise on the water, a bespoke Turkish breakfast on your private terrace, and a hammam ritual to end the day.',
    image: 'https://images.unsplash.com/photo-1658780986409-a406f44bfc8d?auto=format&fit=crop&w=2000&q=80',
  },
  {
    id: 'e2',
    tag: 'Stay Longer',
    title: 'The Fourth Night, With Our Compliments',
    desc: 'Extend your stay and receive the fourth night as our gift, along with daily breakfast for two.',
    image: 'https://images.unsplash.com/photo-1590381105924-c72589b9ef3f?auto=format&fit=crop&w=2000&q=80',
  },
  {
    id: 'e3',
    tag: 'Culinary Journey',
    title: 'Chef’s Table on the Strait',
    desc: 'A seven-course tasting menu curated by our Executive Chef, paired with rare Anatolian vintages.',
    image: 'https://images.unsplash.com/photo-1663530761401-15eefb544889?auto=format&fit=crop&w=2000&q=80',
  },
  {
    id: 'e4',
    tag: 'Family Escape',
    title: 'Istanbul, Through Little Eyes',
    desc: 'A private guided tour of the Old City, curated for families, ending with baklava at our terrace.',
    image: 'https://images.unsplash.com/photo-1583014458773-7c633737edc9?auto=format&fit=crop&w=2000&q=80',
  },
];

export const rooms = [
  {
    id: 'r1',
    name: 'Deluxe Bosphorus Room',
    size: '52 m² / 560 ft²',
    view: 'Bosphorus & Garden',
    beds: 'King or Twin',
    desc: 'A refined sanctuary where soft linens meet a private balcony opening onto the strait.',
    image: 'https://images.unsplash.com/photo-1685592437742-3b56edb46b15?auto=format&fit=crop&w=2000&q=80',
    highlights: ['Private balcony', 'Marble bathroom', 'Bosphorus view', 'Nespresso bar'],
    price: 'from €780 / night',
  },
  {
    id: 'r2',
    name: 'Superior Garden Room',
    size: '48 m² / 517 ft²',
    view: 'Ottoman Gardens',
    beds: 'King or Twin',
    desc: 'Quiet elegance overlooking the century-old gardens, with hand-woven Anatolian textiles.',
    image: 'https://images.unsplash.com/photo-1777169794972-12095816073b?auto=format&fit=crop&w=2000&q=80',
    highlights: ['Garden terrace', 'Rain shower', 'Reading nook', 'Turkish tea ritual'],
    price: 'from €640 / night',
  },
  {
    id: 'r3',
    name: 'Bosphorus Suite',
    size: '95 m² / 1022 ft²',
    view: 'Panoramic Bosphorus',
    beds: 'King',
    desc: 'A generous suite with a separate living room and floor-to-ceiling views of the water.',
    image: 'https://images.unsplash.com/photo-1559414059-34fe0a59e57a?auto=format&fit=crop&w=2000&q=80',
    highlights: ['Separate lounge', 'Butler service', 'Freestanding bath', 'Private terrace'],
    price: 'from €1 450 / night',
  },
  {
    id: 'r4',
    name: 'Terrace Suite',
    size: '120 m² / 1290 ft²',
    view: 'Bosphorus & Old City',
    beds: 'King',
    desc: 'A statement suite framed by a private wraparound terrace, ideal for sunset dining.',
    image: 'https://images.unsplash.com/photo-1507652313519-d4e9174996dd?auto=format&fit=crop&w=2000&q=80',
    highlights: ['Wraparound terrace', 'Outdoor dining', 'Walk-in dressing', 'Hammam bath'],
    price: 'from €2 100 / night',
  },
  {
    id: 'r5',
    name: 'Signature Suite',
    size: '260 m² / 2798 ft²',
    view: 'Full Bosphorus Panorama',
    beds: 'King + Study',
    desc: 'Our flagship residence — two bedrooms, a private hammam, and a cinematic Bosphorus panorama.',
    image: 'https://images.unsplash.com/photo-1660557989695-14fac79c086d?auto=format&fit=crop&w=2000&q=80',
    highlights: ['Private hammam', 'Grand piano', 'Chef on request', 'Chauffeured arrival'],
    price: 'on request',
  },
];

export const restaurants = [
  {
    id: 'd1',
    category: 'Fine Dining',
    name: 'Decamondo Bosphorus',
    desc: 'A modern Anatolian tasting journey, guided by seasonal produce and the sea beyond the terrace.',
    image: 'https://images.unsplash.com/photo-1551632436-cbf8dd35adfa?auto=format&fit=crop&w=2000&q=80',
    hours: 'Dinner · 19:00 – 23:30',
  },
  {
    id: 'd2',
    category: 'Lounge',
    name: 'Lounge',
    desc: 'An intimate lounge for morning coffee, afternoon tea and evening cocktails.',
    image: 'https://images.unsplash.com/photo-1536392706976-e486e2ba97af?auto=format&fit=crop&w=2000&q=80',
    hours: 'Daily · 08:00 – 01:00',
  },
  {
    id: 'd3',
    category: 'Terrace Bar',
    name: 'Terrace Bar',
    desc: 'Signature cocktails, Aegean small plates and unmatched sunset views over the strait.',
    image: 'https://images.unsplash.com/photo-1658780986409-a406f44bfc8d?auto=format&fit=crop&w=2000&q=80',
    hours: 'Seasonal · 17:00 – 01:00',
  },
  {
    id: 'd4',
    category: 'All-Day Dining',
    name: 'The Bosphorus Dining Room',
    desc: 'A light-filled all-day restaurant offering Mediterranean and Turkish classics.',
    image: 'https://images.unsplash.com/photo-1663530761401-15eefb544889?auto=format&fit=crop&w=2000&q=80',
    hours: 'Daily · 06:30 – 23:00',
  },
];

export const wellness = {
  title: 'The Spa at Decamondo',
  desc: 'A serene retreat inspired by the centuries-old Turkish hammam tradition, reimagined with contemporary craft. Marble chambers, quiet water, and rituals shaped for the modern traveller.',
  image: 'https://images.unsplash.com/photo-1604161926875-bb58f9a0d81b?auto=format&fit=crop&w=2400&q=80',
  points: ['Traditional Turkish hammam', 'Couple’s treatment suites', '25 m indoor pool', 'Bespoke wellness journeys'],
};

export const events = {
  title: 'Weddings & Celebrations',
  desc: 'From an intimate proposal on the water to a grand celebration under the stars, our team crafts moments that endure.',
  image: 'https://images.unsplash.com/photo-1536392706976-e486e2ba97af?auto=format&fit=crop&w=2400&q=80',
};

export const explore = [
  { id: 'x1', title: 'Istanbul, After Dark', image: 'https://images.unsplash.com/photo-1696711551721-458511adcd86?auto=format&fit=crop&w=1600&q=80' },
  { id: 'x2', title: 'The Old City', image: 'https://images.unsplash.com/photo-1763965367072-54870fc7f1b6?auto=format&fit=crop&w=1600&q=80' },
  { id: 'x3', title: 'A Private Bosphorus Cruise', image: 'https://images.unsplash.com/photo-1665512961534-7d42056eeedf?auto=format&fit=crop&w=1600&q=80' },
  { id: 'x4', title: 'Grand Bazaar Curated', image: 'https://images.unsplash.com/photo-1583014458773-7c633737edc9?auto=format&fit=crop&w=1600&q=80' },
];

export const meetings = {
  title: 'Meetings & Boardrooms',
  desc: 'Four intimate meeting spaces and one grand ballroom, each with natural light and dedicated event concierge.',
  image: 'https://images.unsplash.com/photo-1431540015161-0bf868a2d407?auto=format&fit=crop&w=2400&q=80',
};

export const pool = {
  title: 'The Infinity Pool',
  desc: 'Suspended above the strait, our heated infinity pool blurs the line between water and sky.',
  image: 'https://images.unsplash.com/photo-1543489822-c49534f3271f?auto=format&fit=crop&w=2400&q=80',
};

export const gifts = [
  { id: 'g1', title: 'A Night on the Bosphorus', desc: 'An overnight stay with breakfast for two.', image: 'https://images.unsplash.com/photo-1488345979593-09db0f85545f?auto=format&fit=crop&w=1600&q=80' },
  { id: 'g2', title: 'The Hammam Ritual', desc: 'A traditional Turkish bath followed by afternoon tea.', image: 'https://images.unsplash.com/photo-1604161926875-bb58f9a0d81b?auto=format&fit=crop&w=1600&q=80' },
  { id: 'g3', title: 'Chef’s Tasting Menu', desc: 'A seven-course dinner with wine pairings for two.', image: 'https://images.unsplash.com/photo-1551632436-cbf8dd35adfa?auto=format&fit=crop&w=1600&q=80' },
];

export const faqs = [
  { q: 'When is check-in and check-out?', a: 'Check-in is from 15:00 and check-out is until 12:00. Early check-in and late check-out are offered subject to availability.' },
  { q: 'Is airport transfer available?', a: 'Yes — chauffeured arrivals from Istanbul Airport (IST) and Sabiha Gökçen (SAW) can be arranged through our concierge.' },
  { q: 'Do you accommodate children?', a: 'Families are warmly welcomed. We offer connecting suites, in-room amenities and curated activities for younger guests.' },
  { q: 'Are pets allowed?', a: 'Small pets are welcome upon prior arrangement. Please contact reservations for details.' },
  { q: 'What is your cancellation policy?', a: 'Most rates are fully flexible up to 48 hours before arrival. Non-refundable rates are marked at booking.' },
  { q: 'Do you offer private events?', a: 'From proposals to full-buyouts, our events team designs celebrations of every scale.' },
];

export const footerLinks = {
  hotel: ['The Hotel', 'Rooms & Suites', 'Dining', 'Spa & Wellness', 'Meetings', 'Weddings'],
  discover: ['Istanbul', 'Experiences', 'Gifts', 'Stories', 'Sustainability'],
  brand: ['About Decamondo', 'Careers', 'Press', 'Contact', 'Privacy', 'Terms'],
};
